import React from "react";
import { ThemeProvider } from "styled-components"
import Layout from "../components/layout"
import SEO from "../components/seo";
import ReNavigation from "sections/ReNavigation";
import Banner from "sections/ReBannerTwo";
import Service from "sections/ReService";
import ReContact from "sections/reContact";
import Footer from "sections/Footer";
import BannerImage from "assets/images/index.png";
import theme from "assets/theme/theme";
import GlobalStyle from "assets/theme";
import {GrConnect, GrIntegration, GrServices} from 'react-icons/gr'
import { FaMask, FaRobot } from "react-icons/fa";
import { VscDebugDisconnect } from "react-icons/vsc";
import {MdDataUsage} from "react-icons/md"
import {GiGears, GiSpiderWeb} from "react-icons/gi"


//{h1, p1, span, cta, iconCta, image}
const IndexPage = () => {
const data = {
  services: [
    {
      icon: <GiSpiderWeb size="7.5em" color="white"/>,
      title: "Web Scraping",
      body: "Obtenemos la data que necesites a la velocidad del paralelismo",
      link: "/web-scraping/"
    },
    {
      icon: <FaRobot size="7.5em" color="white"/>,
      title: "RPA",
      body: "Automatizamos tus tareas, al menor costo posible",
      link: "/rpa-chile/"
    },
    {
      icon: <VscDebugDisconnect size="7.5em" color="white"/>,
      title: "Integraciones SAP",
      body: "Articulamos cualquier aplicación con tus modulos SAP",
    },
    {
      icon: <MdDataUsage size="7.5em" color="white"/>,
      title: "Data As A Service",
      body: "Te brindamos la data que necesites sin necesidad de servidores",
    },

    
  ],
}

return (
<ThemeProvider theme={theme}>
    <GlobalStyle />
    <Layout>
      <SEO title="Home" />
      <ReNavigation />
      <Banner h1="PATLAB" 
              p1="Transformación digital" 
              span="Somos una empresa de desarrollo de software a medida. Nos enfocamos en  la automatización e integración de procesos que aportan valor a tu negocio"
              cta="Servicios"
              image={BannerImage}
              iconCta={<GiGears style={{ color: "#FFFF"}}/>}
              />
      <Service data={data} />
      <ReContact />
      <Footer />
    </Layout>
  </ThemeProvider>
)
}

export default IndexPage
